import { axios } from '@/utils/request'

/**
 * 查询问诊记录管理
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function inquirymanagePage (parameter) {
  return axios({
    url: '/inquirymanage/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 问诊记录管理列表
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function inquirymanageList (parameter) {
  return axios({
    url: '/inquirymanage/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加问诊记录管理
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function inquirymanageAdd (parameter) {
  return axios({
    url: '/inquirymanage/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑问诊记录管理
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function inquirymanageEdit (parameter) {
  return axios({
    url: '/inquirymanage/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除问诊记录管理
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function inquirymanageDelete (parameter) {
  return axios({
    url: '/inquirymanage/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出问诊记录管理
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function inquirymanageExport (parameter) {
  return axios({
    url: '/inquirymanage/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}


/**
 * 查询问诊记录管理详情
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function recipeDetial (parameter) {
  return axios({
    url: '/inquirymanage/detail',
    method: 'get',
    params: parameter,
  })
}



/**
 * 导出聊天记录
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function exportRecord(parameter) {
  return axios({
    url: '/inquirymanage/chat/export',
    method: 'get',
    params: parameter,
    responseType : 'blob'
  })
}


/**
 * 查看视频文件
 *
 * @author liwei
 * @date 2022-04-08 11:30:53
 */
export function exportFile(parameter) {
  return axios({
    url: '/inquirymanage/chat/videoExport',
    method: 'get',
    params: parameter,
  })
}
